/**
 * Revenue Breakdown Coloring System
 * Centralizes all color palettes and resolution logic for revenue segments.
 */

export const SOURCE_PALETTE = [
    '#10b981', // emerald-500
    '#3b82f6', // blue-500
    '#6366f1', // indigo-500
    '#f43f5e', // rose-500
    '#f59e0b', // amber-500
    '#8b5cf6', // violet-500
    '#ec4899', // pink-500
    '#06b6d4', // cyan-500
];

export const GRAY_PALETTE = [
    '#d1d5db', // gray-300
    '#9ca3af', // gray-400
    '#6b7280', // gray-500
    '#4b5563', // gray-600
    '#374151', // gray-700
];

export const ORGANIC_BLUE = '#3b82f6';

/**
 * Resolves the color for a main source row (e.g., in TrafficPage table or bar).
 */
export const getSourceRowColor = (index: number) => {
    return SOURCE_PALETTE[index % SOURCE_PALETTE.length];
};

/**
 * Resolves the color for a sub-source segment (Connectivity bar).
 * Encapsulates the logic for organic, active, and inactive states.
 */
export const getSubSourceSegmentColor = (
    index: number,
    statusProps: { 
        isOrganic?: boolean; 
        isActive?: boolean; 
        isPaid?: boolean 
    }
) => {
    const { isOrganic, isActive } = statusProps;

    if (isOrganic) return ORGANIC_BLUE;

    if (isActive) {
        // Offset the palette for sub-sources to differentiate from main sources if needed
        return SOURCE_PALETTE[(index + 4) % SOURCE_PALETTE.length];
    }

    // Inactive or unmatched
    return GRAY_PALETTE[index % GRAY_PALETTE.length];
};
